module.exports = "/React/dist/84dac3c7c29ac17d84c6d57f124c34af.png";